import { render, staticRenderFns } from "./DishesConfirm.vue?vue&type=template&id=b66f77be&scoped=true&"
import script from "./DishesConfirm.vue?vue&type=script&lang=js&"
export * from "./DishesConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DishesConfirm.vue?vue&type=style&index=0&id=b66f77be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66f77be",
  null
  
)

export default component.exports